<template>
  <!-- Filters -->
  <div class="filter-box">
    <div class="filters">
      <form class="filter" @submit.prevent="filterConcerts" tabindex="-1">
        <input type="text" name="filterTerm" id="filterTerm" class="form-control me-2" placeholder="Zoek een band, stad of genre…" v-model="searchTerm">
        <button type="submit" class="btn btn-outline-light btn-lg">Zoeken</button>
      </form>
    </div>
  </div>

  <!-- HUMO recommends concerts -->
  <div class="concert-grid" v-if="recommendedConcerts && recommendedConcerts.length > 0">
    <div class="grid-title">
      <h2 class="title tips-only-title">Humo tipt</h2>
    </div>

    <div class="grid-wrapper">
      <Concert    v-for="concert in recommendedConcerts"
                  :key="concert.slug"
                  :concert="concert"
      ></Concert>
    </div>
  </div>

  <!-- Grid of concerts -->
  <div class="concert-grid" id="allConcerts">
    <div class="grid-title">
      <h2 class="title all-title">
        <template v-if="!filtered">Alle concerten</template>
        <template v-else>Zoekresultaten</template>
      </h2>
    </div>

    <div class="grid-wrapper">
      <Concert    v-for="concert in filteredConcerts"
                  :key="`concert-${concert.id}`"
                  :concert="concert"
      ></Concert>
      <!-- Placeholder when no results-->
      <div
        class="concert-wrapper"
        v-if="filteredConcerts && filteredConcerts.length < 1"
      >
        <div class="concert">
          <div class="title-box">
            <h3 class="concert-title">Geen resultaten</h3>
          </div>
          <div class="info">
            <p class="description">
              Er zijn geen concerten gevonden die voldoen aan de opgegeven
              filters.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script async setup>
import { computed, onMounted, ref } from 'vue'
import Concert from '@/components/Concert.vue'
import Fuse from 'fuse.js'
import axios from 'axios'

const concerts = ref([])
const props = defineProps({ tipsOnly: Boolean })
const searchTerm = defineModel()
const filteredConcerts = ref([])
const filtered = ref(false)
const loading = ref(false)

onMounted(() => {
  getConcerts()
})

function getConcerts() {
  const baseUrl = window.location.origin
  const url = `${baseUrl}/json/concerts.json?v=${Date.now()}`
  loading.value = true

  axios.get(url).then((response) => {
    concerts.value = response.data
    filteredConcerts.value = response.data
  }).catch(error => {
    console.error(error)
  }).finally(() => {
    loading.value = false
  })
}

// filter concerts on form submit
function filterConcerts() {
  const options = {
    minMatchCharLength: 3,
    keys: ['name', 'artist', 'city', 'genre', 'venue', 'tags'],
    shouldSort: false,
    findAllMatches: true,
    threshold: 0.2
  }

  if (searchTerm.value.length > 2 && concerts.value?.length > 0) {
    filtered.value = true
    const fuse = new Fuse(concerts.value, options)
    const results = fuse.search(searchTerm.value)
    const resultsEl = document.getElementById('allConcerts')
    filteredConcerts.value = results.map(result => result.item)
    resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
  } else {
    filtered.value = false
    filteredConcerts.value = concerts.value?.length > 0 ? concerts.value : []
  }
}

const recommendedConcerts = computed(() => {
  if (concerts.value.length > 0) {
    const concertArray = concerts.value.filter(concert => concert.humo_recommends)
    const shuffled = concertArray.sort(() => 0.5 - Math.random())
    return shuffled.slice(0, 3)
  } else return []
})
</script>
